import MESSAGES from './messages';

export const RAW = 'RAW';
export const TEXT = 'TEXT';
export const IFRAME = 'IFRAME';
export const SUPERSET = 'SUPERSET';

export const PAGES_TYPES = [
    {
        value: 'RAW',
        label: MESSAGES.rawHtml,
    },
    {
        value: 'TEXT',
        label: MESSAGES.text,
    },
    {
        value: 'IFRAME',
        label: MESSAGES.iframe,
    },
    {
        value: 'SUPERSET',
        label: MESSAGES.superset,
    },
];
